// REACT & REDUX
import { connect } from 'react-redux';

// STYLE, PROPS & TRANSLATIONS

// COMMON

// COMPONENTS
import  Upload  from './Upload.component';
import { CERTIFICATE_SUBMIT_FORM } from '../../actions/actionTypes';
import { dropFileCompleted, clientSecretsInitialize, selectedRiziv, uploadCertificate } from '../../actions/certificate.actions';
import { submit } from 'redux-form';

// CONTAINERS

// ACTIONS & API

// *************************************************************************************************************************************
function mapStateToProps(state) {
    const slice = state.uploadFiles || {};
    return {
        files: slice.files,
        clientSecrets: slice.clientSecrets,
        disableUploadButton: slice.disableUploadButton
    };
}

const mapDispatchToProps =  {

        submitForm: () => submit(CERTIFICATE_SUBMIT_FORM),
        upload: uploadCertificate,
        dropFileCompleted,
        clientSecretsInitialize,
        selectedRiziv

}

export default connect(mapStateToProps, mapDispatchToProps)(Upload);